<template>
  <v-main class="d-flex align-center justify-center h-screen">
    <v-card width="1100" class="pa-4 error-card">
      <v-card-title class="screen-title"> SSOログイン失敗 </v-card-title>
      <v-card-text class="pt-4">
        SSOログインに失敗しました。再度お試しください。</v-card-text
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn to="/login" color="primary" variant="flat">ログイン画面</v-btn>
      </v-card-actions>
    </v-card>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SsoFailedView",
});
</script>
